import { HStack, Text, VStack } from '@chakra-ui/react';
import { Icon } from '@jurnee/common/src/components/Icon';
import { SecondaryButton } from '@jurnee/common/src/components/primitives/buttons/SecondaryButton';
import { Currency } from '@jurnee/common/src/entities/Currency';
import { formatDate } from '@jurnee/common/src/utils/dates';
import { formatPrice } from '@jurnee/common/src/utils/prices';
import { useTranslation } from 'react-i18next';

interface Props {
  type: 'CREDIT_CARD' | 'WIRE_TRANSFER' | 'BANK_CARD';
  amount: number;
  currency: Currency;
  date: string | Date;
  onDownload?: () => void;
}

export function PaymentLine({ type, amount, currency, date, onDownload }: Props) {
  const { t } = useTranslation('invoice', { keyPrefix: 'paymentDocument' });

  const displayAmount = formatPrice(amount, currency);

  return (
    <HStack w="100%" justifyContent="space-between">
      <VStack w="30%" spacing={0} alignItems="flex-start">
        <Text fontWeight={700}>{t('paidBy')}</Text>
        <Text color="gray.400">{t(`type.${type}`)}</Text>
      </VStack>

      <VStack w="30%" spacing={0} alignItems="flex-start">
        <Text fontWeight={700}>{t('paidAt')}</Text>
        <Text color="gray.400">{formatDate(new Date(date))}</Text>
      </VStack>

      <VStack w="30%" spacing={0} alignItems="flex-start">
        <Text fontWeight={700}>{t('amount')}</Text>
        <Text color="gray.400">{displayAmount}</Text>
      </VStack>

      {onDownload ? (
        <SecondaryButton
          w="32px"
          h="32px"
          minW="32px"
          borderRadius={4}
          colorScheme="gray"
          onClick={onDownload}
        >
          <Icon icon="download" size={5} />
        </SecondaryButton>
      ) : (
        <HStack w="32px" minW="32px" />
      )}
    </HStack>
  );
}
